import type { JSX } from "react";

/**
 * CycleCare brand mark. Uses the official transparent logo asset (served from
 * /public) so it is pixel-identical to the provided design and works on any
 * background in both light and dark mode.
 */
export function BrandLogo({ size = 24 }: { size?: number }): JSX.Element {
  return (
    <img
      className="brand-logo"
      src="/cyclecare-logo.svg"
      width={size}
      height={size}
      alt="CycleCare"
    />
  );
}
